import { round } from 'lodash';

export const normalizeProgresValue = (
  totalDays: number,
  restDays: number,
): number => round((restDays * 100) / totalDays);

export const getColors = (
  restDays: number,
): { border: string; text: string; progress: string } => {
  if (restDays <= 3) {
    return {
      border: '#b61818',
      text: '#520b0b',
      progress: '#ffdcdc',
    };
  }

  if (restDays <= 7 && restDays > 3) {
    return {
      border: '#b69618',
      text: '#69560e',
      progress: '#faffdc',
    };
  }

  return {
    border: '#5618b6',
    text: '#2a0c59',
    progress: '#e9dcff',
  };
};
